import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SocialService } from 'app/services/social-service';
import Swal from 'sweetalert2';

@Component({
  standalone: true,
  selector: 'app-social-auth',
  templateUrl: './social-auth.component.html'
})
export class SocialAuthComponent implements OnInit {

  constructor(private router: Router, private socialService: SocialService) { }

  ngOnInit(): void {
    const url = new URL(window.location.href);
    const token = url.searchParams.get('token');
    const type = url.searchParams.get('type');
    const email = url.searchParams.get('email');

    if (token && type) {
      if (email) {
        sessionStorage.setItem('email', email);
      }
      this.handleAuthToken(token, type);
    }
  }

  private async handleAuthToken(token: string, type: string) {
    try {
      await this.socialService.login({ socialToken: token, socialType: type });
    } catch {
      try {
        await this.socialService.register({ socialToken: token, socialType: type });
      } catch {
        Swal.fire({
          icon: 'error',
          title: 'Something went wrong',
          text: 'Please try again later.',
          confirmButtonText: 'Go Home'
        }).then(() => {
          this.router.navigate(['/']);
        });
      }
    }
  }
}

